export const environment = {
  label: 'dev',
  production: false,
  internalAdminProxyBaseUri: 'https://2yqg566wo6.execute-api.eu-west-1.amazonaws.com/dev',
  internalAdminServiceBaseUri: 'https://8xv3wguiwl.execute-api.eu-west-1.amazonaws.com/dev',
  websocketEndpoint: '',
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_wugVVXNRG',
      userPoolClientId: '7n2d31j4tou25kmk906sdkanpj',
      loginWith: {
        oauth: {
          domain: 'cognito-idp.eu-west-1.amazonaws.com',
          scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['https://internal-admin-app.dev.northrowtest.com/'],
          redirectSignOut: ['https://internal-admin-app.dev.northrowtest.com/'],
          responseType: 'code',
        },
      },

    },
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  }
};
